import React, { useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import clsx from 'clsx';

import useScrollDirection from '@ecp/common/src/hooks/useScrollDirection';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { gnbDefault } from '@ecp/common/src/const/home/gnbConst';

import { withGnbMenuList } from '@mo-recoil/common/menu/selector';
import { gnbTypeState } from '@mo-recoil/common/gnb/atom';
import { appStoreLinkBannerState } from '@mo-recoil/banner/atom';
import { menuListState } from '@mo-recoil/common/menu/atom';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import mainFunctionApi from '@mo-apis/display/mainFunctionApi';
import Cart from '@mo-components/common/gnb/Cart';
import { ReactComponent as GoBackIcon } from '@mo-assets/icon/icon__go_back.svg';
import SkypassGnbMenu from '@ecp/mo/sites/skypass/components/gnb/SkypassGnbMenu';
import { Container, Logo } from '@ecp/mo/sites/skypass/styles/gnb/SkypassGnbStyles';

export default function SkypassGnb() {
  const {
    isCartUse,
    systemInformation: { mobileGnbImgFilePath },
    siteNumber,
  } = useSiteInfo();
  const scrollDirection = useScrollDirection({ siteNumber: siteNumber });
  const scrollDirectionStyle = clsx(scrollDirection);
  const type = useRecoilValue(gnbTypeState);
  const navigate = useNavigate();
  const appLinkBanner = useRecoilValue(appStoreLinkBannerState);
  const gnbMenuList = useRecoilValue(withGnbMenuList);
  const setMenuList = useSetRecoilState(menuListState);

  useEffect(() => {
    (async () => {
      try {
        await fetchGnbMenuList();
      } catch (e) {
        console.error(e);
      }
    })();
  }, [fetchGnbMenuList]);

  const isMenu = useMemo(() => type === gnbTypes.MENU, [type]);

  const fetchGnbMenuList = useCallback(async () => {
    const { result } = await mainFunctionApi.getGnbList();
    const gnbList = result.map(({ title, bullet, fontColorCode, highLight, mobileNewWindow, mobileUrl }) => ({
      title,
      link: mobileUrl,
      dot: bullet,
      bold: highLight,
      color: fontColorCode ? `#${fontColorCode}` : gnbDefault.color,
      target: mobileNewWindow ? '_blank' : '_self',
    }));
    setMenuList(gnbList);
  }, [setMenuList]);

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleGoBackClick = () => {
    navigate(-1);
  };

  return (
    <>
      <Container className={scrollDirectionStyle} appLinkBanner={appLinkBanner}>
        {isMenu ? (
          <>
            <FlexBox>
              <Logo onClick={handleHomeClick} data-ds-label2={'g_logo'} src={mobileGnbImgFilePath} />
            </FlexBox>
          </>
        ) : (
          <FlexBox>
            <GoBackIcon onClick={handleGoBackClick} data-ds-label2={'g_back'} />
            <Spacing left={14} />
            <Logo onClick={handleHomeClick} data-ds-label2={'g_logo'} src={mobileGnbImgFilePath} />
          </FlexBox>
        )}
        {isCartUse && <Cart />}
      </Container>
      {isMenu && <SkypassGnbMenu gnbMenuList={gnbMenuList} />}
      <FlexBox width={'360px'} height={isMenu ? '80px' : '46px'} />
    </>
  );
}

export const gnbTypes = {
  MENU: 'menu',
};
